import { Inject, Injectable } from '@angular/core';

import { GoogleTagManagerService } from 'angular-google-tag-manager';

import { EnvironmentInterface, GoogleTagEventType } from '../../types';

@Injectable({
    providedIn: 'root'
})
export class AnalyticsService {
    environment: EnvironmentInterface;
    enableGoogleAnalytics: boolean = false;

    //Set up GTM configurations in the specific projects
    constructor(
        private gtmService: GoogleTagManagerService,
        @Inject('environment') environment: EnvironmentInterface
    ) {
        this.environment = environment;
        this.enableGoogleAnalytics = environment?.analytics?.enableGoogleAnalytics || false;
    }

    pushGTMTag(val: GoogleTagEventType) {
        if (!this.enableGoogleAnalytics) {
            console.log('Google Tag Manager has been disabled');
            return;
        } else if (!this.environment.analytics.googleTagManagerId) {
            console.log('No GTM id');
            return;
        }
        this.gtmService.pushTag(val);
    }
}
